var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramComment = function SvgInstagramComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666664",
    d: "M15.076 16.317a8.89 8.89 0 0 0 2.894-6.57c0-4.91-3.996-8.906-8.907-8.906C4.153.84.157 4.836.157 9.747c0 5.868 5.623 10.176 11.32 8.574 4.47 1.027 4.235.989 4.336.989a.469.469 0 0 0 .42-.679l-1.157-2.314Zm-3.611 1.052a.472.472 0 0 0-.133.019C6.2 18.908 1.095 15.035 1.095 9.747c0-4.394 3.575-7.969 7.968-7.969 4.394 0 7.97 3.575 7.97 7.969a7.956 7.956 0 0 1-2.84 6.098.469.469 0 0 0-.117.568l.873 1.747c-3.555-.816-3.384-.791-3.484-.791Z"
  })));
};
export default SvgInstagramComment;